import { getDatadogRumInstance } from '@tcc/analytics';
import envDetect from '@tcc/env-detect';
import { POLL_INTERVAL } from '../../../../../constants/shortPolling';
import {
  ArdRegionReportEntryPoint,
  ReportArdRegionReportRequestStartedParams,
  ReportArdRegionReportSessionParams,
} from './types/telemetry';

const ARD_FRR_RUM_ACTION = 'ard.frr.report_session';
const ARD_FRR_REQUEST_STARTED_RUM_ACTION = 'ard.frr.report_request_started';

export const reportArdRegionReportRequestStarted = ({
  activityExists,
  queryParams,
}: ReportArdRegionReportRequestStartedParams) => {
  const context = {
    field_id: queryParams.fieldUUID,
    frr_entry_point: activityExists
      ? ArdRegionReportEntryPoint.CreatedRegion
      : ArdRegionReportEntryPoint.NewRegion,
    season_year: queryParams.seasonYear,
    season_name: queryParams.seasonName,
    crop_id: queryParams.cropId,
  };

  if (!envDetect.isEC2()) {
    // eslint-disable-next-line no-console
    console.warn('[debug] ARD FRR RUM action', {
      action: ARD_FRR_REQUEST_STARTED_RUM_ACTION,
      context,
    });
  }

  getDatadogRumInstance().addAction(ARD_FRR_REQUEST_STARTED_RUM_ACTION, context);
};

export const reportArdRegionReportSession = ({
  activityExists,
  lifecycle,
  options = {},
  outcome,
  queryParams,
  sessionStartedAt,
}: ReportArdRegionReportSessionParams) => {
  const {
    requestId,
    cached,
    resumed,
    pollAttemptCount,
    submitStartedAt,
    submitCompletedAt,
    pollingStartedAt,
    pollingCompletedAt,
    reportFetchStartedAt,
    reportFetchCompletedAt,
  } = lifecycle;

  const context = {
    outcome,
    ...(options.failureStage ? { failure_stage: options.failureStage } : {}),
    ...(options.errorType ? { error_type: options.errorType } : {}),
    ...(options.error ? { error: options.error } : {}),
    request_id: requestId,
    cached: cached ?? false,
    resumed: resumed ?? false,
    frr_entry_point: activityExists
      ? ArdRegionReportEntryPoint.CreatedRegion
      : ArdRegionReportEntryPoint.NewRegion,
    season_year: queryParams.seasonYear,
    season_name: queryParams.seasonName,
    crop_id: queryParams.cropId,
    modal_session_duration_ms: Math.round(performance.now() - sessionStartedAt),
    ...(submitStartedAt && submitCompletedAt ? {
      submit_duration_ms: submitCompletedAt - submitStartedAt,
    } : {}),
    ...(pollingStartedAt && pollingCompletedAt ? {
      polling_duration_ms: pollingCompletedAt - pollingStartedAt,
    } : {}),
    ...(reportFetchStartedAt && reportFetchCompletedAt ? {
      report_fetch_duration_ms: reportFetchCompletedAt - reportFetchStartedAt,
    } : {}),
    poll_interval_ms: POLL_INTERVAL,
    poll_attempt_count: pollAttemptCount,
  };

  if (!envDetect.isEC2()) {
    // eslint-disable-next-line no-console
    console.warn('[debug] ARD FRR RUM action', {
      action: ARD_FRR_RUM_ACTION,
      context,
    });
  }

  getDatadogRumInstance().addAction(ARD_FRR_RUM_ACTION, context);
};